import { get } from '@core/api/baseApi';
import { GetModalitiesResponse } from '@core/types';

const getModalities = async (): Promise<GetModalitiesResponse> => await get('/Studies/modalities');

export default getModalities;
